import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { RiCheckboxLine } from '@remixicon/react';
import { rootRouteRef } from './routes';

export const variaEntityValidatorPage = PageBlueprint.make({
  params: {
    path: '/entity-validator',
    routeRef: rootRouteRef,
    loader: () => import('./components/EntityValidator').then(m => <m.EntityValidator />),
  },
});

export default createFrontendPlugin({
  pluginId: 'varia-entity-validator',
  title: 'Entity Validator',
  icon: <RiCheckboxLine />,
  extensions: [variaEntityValidatorPage],
  routes: {
    root: rootRouteRef,
  },
});
